export const SHIPMENT_PASTE_MAX_UNIQUE_SKUS = 10_000

export type ShipmentSkuReviewItem = {
  sku: string
  matched: boolean
}

export function pastedShipmentSkus(text: string): string[] {
  return uniqueShipmentSkus(text.split(/[\r\n,]+/))
}

export function uniqueShipmentSkus(skus: string[]): string[] {
  const seen = new Set<string>()
  const unique: string[] = []
  for (const raw of skus) {
    const sku = raw.trim()
    if (sku.length === 0 || seen.has(sku)) {
      continue
    }
    seen.add(sku)
    unique.push(sku)
  }
  return unique
}

export function shipmentSkuReviewCounts(items: ShipmentSkuReviewItem[]): {
  matched: number
  notInLex: number
  total: number
} {
  let matched = 0
  for (const item of items) {
    if (item.matched) {
      matched += 1
    }
  }
  return {
    matched,
    notInLex: items.length - matched,
    total: items.length,
  }
}

export function defaultShipmentSkuReviewShowsAll(
  items: ShipmentSkuReviewItem[]
): boolean {
  return items.every((item) => item.matched)
}

export function visibleShipmentSkuReviewItems(
  items: ShipmentSkuReviewItem[],
  showAll: boolean
): ShipmentSkuReviewItem[] {
  if (showAll) {
    return items
  }
  return items.filter((item) => !item.matched)
}
